export const RELIGIOUS_AFFILIATION = [
  { value: "ANY", label: "All" },
  { value: "Christianity", label: "Christianity" },
  { value: "Catholic", label: "Catholic" },
  { value: "Protestant", label: "Protestant" },
  { value: "Baptist", label: "Baptist" },
  { value: "Methodist", label: "Methodist" },
  { value: "Lutheran", label: "Lutheran" },
  { value: "Presbyterian", label: "Presbyterian" },
  { value: "Orthodox", label: "Orthodox" },
  { value: "Islam", label: "Islam" },
  { value: "Judaism", label: "Judaism" },
  { value: "Hinduism", label: "Hinduism" },
  { value: "Buddhism", label: "Buddhism" },
  { value: "Sikhism", label: "Sikhism" },
  { value: "Atheist", label: "Atheist" },
  { value: "Agnostic", label: "Agnostic" },
  { value: "Spiritual", label: "Spiritual but not religious" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];
